// Simple i18n module - TR / EN / DE
const tr = {
    appName: "MyTACS",
    login: "Giriş Yap",
    logout: "Çıkış",
    email: "Email",
    password: "Şifre",
    loginTitle: "Hesabınıza giriş yapın",
    loginSubtitle: "Şirketinizin görev yönetim sistemine hoş geldiniz",
    welcome: "Hoş geldin",
    dashboard: "Dashboard",
    spaces: "Departmanlar",
    calendar: "Takvim",
    admin: "Yönetim Paneli",
    notifications: "Bildirimler",
    noNotifications: "Henüz bildirim yok",
    markAllRead: "Tümünü okundu işaretle",
    created: "Oluşturulanlar",
    taken: "İşleme Alınanlar",
    working: "İşlemde Olanlar",
    completed: "Tamamlanmış",
    total: "Toplam Görev",
    newTask: "Yeni Görev",
    newSpace: "Yeni Departman",
    title: "Başlık",
    description: "Açıklama",
    deadline: "Termin (Deadline)",
    priority: "Öncelik",
    low: "Düşük",
    medium: "Orta",
    high: "Yüksek",
    assignees: "Atananlar",
    attachments: "Ekler",
    subtasks: "Alt Görevler",
    activity: "Aktivite Geçmişi",
    comments: "Yorumlar",
    addComment: "Yorum ekle... (@ ile kişi etiketle)",
    addSubtask: "Alt görev ekle",
    uploadFile: "Dosya yükle",
    delete: "Sil",
    save: "Kaydet",
    cancel: "İptal",
    create: "Oluştur",
    edit: "Düzenle",
    close: "Kapat",
    myTasks: "Bana Atanan Görevler",
    noTasks: "Görev yok",
    selectSpace: "Departman seçin",
    spaceMembers: "Üyeler",
    addMember: "Üye Ekle",
    workers: "Kullanıcılar",
    role: "Rol",
    addWorker: "Kullanıcı Ekle",
    editUser: "Kullanıcıyı Düzenle",
    name: "İsim",
    deletionLog: "Silme Kaydı",
    confirmDelete: "Bu görevi silmek istediğinize emin misiniz?",
    status: "Durum",
    createdAt: "Oluşturulma",
    createdBy: "Oluşturan",
    by: "Yapan",
    assignedYou: "size bir görev atadı",
    mentionedYou: "sizden bahsetti",
    today: "Bugün",
    tomorrow: "Yarın",
    overdue: "Gecikmiş",
    spaceName: "Departman Adı",
    spaceColor: "Renk",
    deleteSpace: "Departmanı Sil",
    confirmDeleteSpace: "Bu departmanı ve içindeki tüm görevleri silmek istediğinize emin misiniz?",
    searchTasks: "Görev ara...",
    allSpaces: "Tüm Departmanlar",
    upcoming: "Yaklaşan",
    deadlines: "Termin Tarihleri",
    noDeadlines: "Yaklaşan termin yok",
    of: "/",
    members: "üye",
    tasks: "görev",
    yourTodos: "To-do listen",
    quickStats: "Hızlı İstatistikler",
    acceptedFormats: "Kabul edilen formatlar",
    uploading: "Yükleniyor",
    leaveBlankKeep: "Boş bırakırsanız mevcut şifre korunur",
    mentionAll: "Herkesi etiketle",
    parentTask: "Üst Görev",
    backToParent: "Üst göreve dön",
    price: "Fiyat",
    currency: "Para Birimi",
    attachFiles: "Dosya ekle",
    filesToUpload: "Yüklenecek dosyalar",
    banking: "Banking",
    invoices: "Faturalar",
    newInvoice: "Yeni Fatura",
    amount: "Tutar",
    dueDate: "Vade Tarihi",
    urgency: "Aciliyet",
    vendor: "Tedarikçi",
    iban: "IBAN",
    invoiceNumber: "Fatura No",
    category: "Kategori",
    recurring: "Tekrar",
    requiresApproval: "Onay Gerekli",
    open: "Açık",
    approved: "Onaylı",
    inProgress: "İşlemde",
    paid: "Ödendi",
    approve: "Onayla",
    markPaid: "Ödendi İşaretle",
    invite: "Davet Et",
    inviteUser: "Kullanıcı Davet Et",
    sentInvitations: "Gönderilen Davetler",
    setPassword: "Şifre Belirle",
    welcomeAccept: "MyTACS'a hoş geldiniz! Şifrenizi belirleyin ve hesabınızı aktive edin.",
    invalidInvite: "Davet geçersiz veya süresi dolmuş",
    user: "Kullanıcı",
    master: "Master",
    spokenAt: "Görüşme tarihi",
    addSpokenAt: "Görüşme tarihi ekle",
    spokenOn: "Görüşme:",
    monthlyChart: "Aylık Genel Bakış",
    expensesByDay: "Güne göre giderler",
    selectMonth: "Ay seçin",
    noExpenses: "Bu ay için gider yok",
    myTodos: "Görevlerim",
    newTodo: "Yeni Görev",
    noTodos: "Henüz görevin yok",
    completedTodos: "Tamamlananlar",
    openTodos: "Açık",
    announcements: "Duyurular",
    newAnnouncement: "Yeni Duyuru",
    announcementSent: "Duyuru gönderildi",
    announcementDescr: "Bu duyuru tüm kullanıcılara pop-up olarak gösterilir ve okunduğunda 'Duyurular' bölümünde kalır.",
    annTitlePlaceholder: "ör. Bugün şirket kredi kartı kullanılacak",
    annContentPlaceholder: "Detayları yaz...",
    markUrgent: "Acil olarak işaretle",
    urgent: "ACİL",
    acknowledge: "Okudum, anladım",
    from: "Gönderen:",
    send: "Gönder",
    content: "İçerik",
    online: "Çevrimiçi",
    offline: "Çevrimdışı",
    lastSeen: "Son görülme",
    phone: "Telefon",
    personnelNumber: "Personel No",
    address: "Adres",
    birthday: "Doğum tarihi",
    hireDate: "İşe giriş tarihi",
    jobTitle: "Pozisyon",
    emergencyContact: "Acil durum kişisi",
    emergencyPhone: "Acil durum telefonu",
    vacationQuota: "Yıllık izin gün sayısı",
    hrDetails: "İK Bilgileri",
    notes: "Notlar",
    employees: "Çalışanlar",
    employeeDirectory: "Çalışan Rehberi",
    sendMessage: "Mesaj gönder",
    newEvent: "Yeni Etkinlik",
    eventTitle: "Etkinlik adı",
    visibility: "Görünürlük",
    personal: "Kişisel",
    team: "Ekip",
    company: "Şirket",
    location: "Konum",
    allDay: "Tüm gün",
    color: "Renk",
    vacation: "İzin",
    vacations: "İzinler",
    newVacationRequest: "Yeni İzin Talebi",
    vacationType: "İzin türü",
    annualLeave: "Yıllık izin",
    specialLeave: "Özel izin",
    unpaidLeave: "Ücretsiz izin",
    sickLeave: "Hastalık izni",
    substitute: "Vekil",
    reason: "Sebep",
    workdays: "İş günü",
    pending: "Beklemede",
    approved: "Onaylandı",
    rejected: "Reddedildi",
    approve: "Onayla",
    reject: "Reddet",
    decide: "Karar ver",
    quota: "Yıllık kontenjan",
    used: "Kullanılan",
    remaining: "Kalan",
    onCall: "Nöbet",
    newOnCall: "Yeni Nöbet",
    selectEmployee: "Çalışan seç",
    whoIsOut: "Bugün izinli",
    assignToSpace: "Tüm departmana ata",
    claimTask: "Görevi al",
    claimedBy: "Alındı:",
    departmentTask: "Departman görevi",
    attach: "Dosya ekle",
    attachments: "Ekler",
    eventColor: "Renk",
    chat: "Sohbet",
    newChat: "Yeni Sohbet",
    newGroup: "Yeni Grup",
    groupName: "Grup adı",
    typeMessage: "Mesaj yaz...",
    noChats: "Henüz sohbet yok",
    noMessages: "Henüz mesaj yok",
    selectChat: "Bir sohbet seç",
    members: "Üyeler",
    typing: "yazıyor...",
    icalSync: "Takvim Senkronizasyonu",
    icalDescr: "MyTACS takvimini Apple/Google/Android'e abone ol. Read-only.",
    copyUrl: "URL'yi kopyala",
    copied: "Kopyalandı!",
    openInApple: "Apple Calendar'da aç",
    customerComms: "Müşteri İletişimi",
    superchat: "Superchat",
    superchatStatus: "Bağlantı durumu",
    superchatConfigured: "API anahtarı ayarlı",
    superchatNotConfigured: "Yapılandırılmadı",
    channel: "Kanal",
    whatsapp: "WhatsApp",
    sms: "SMS",
    email: "E-posta",
    instagram: "Instagram",
    contactId: "Kontak ID",
    sendCustomerMessage: "Müşteriye gönder",
    settings: "Ayarlar",
}; 

const en = {
    appName: "MyTACS",
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    loginTitle: "Sign in to your account",
    loginSubtitle: "Welcome to your company task management system",
    welcome: "Welcome",
    dashboard: "Dashboard",
    spaces: "Spaces",
    calendar: "Calendar",
    admin: "Admin Panel",
    notifications: "Notifications",
    noNotifications: "No notifications yet",
    markAllRead: "Mark all as read",
    created: "Created",
    taken: "Taken",
    working: "Working",
    completed: "Completed",
    total: "Total Tasks",
    newTask: "New Task",
    newSpace: "New Space",
    title: "Title",
    description: "Description",
    deadline: "Deadline",
    priority: "Priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    assignees: "Assignees",
    attachments: "Attachments",
    subtasks: "Subtasks",
    activity: "Activity Log",
    comments: "Comments",
    addComment: "Add a comment... (use @ to mention)",
    addSubtask: "Add subtask",
    uploadFile: "Upload file",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    edit: "Edit",
    close: "Close",
    myTasks: "My Tasks",
    noTasks: "No tasks",
    selectSpace: "Select space",
    spaceMembers: "Members",
    addMember: "Add member",
    workers: "Users",
    role: "Role",
    addWorker: "Add User",
    editUser: "Edit User",
    name: "Name",
    deletionLog: "Deletion Log",
    confirmDelete: "Are you sure you want to delete this task?",
    status: "Status",
    createdAt: "Created",
    createdBy: "Created by",
    by: "by",
    assignedYou: "assigned you a task",
    mentionedYou: "mentioned you",
    today: "Today",
    tomorrow: "Tomorrow",
    overdue: "Overdue",
    spaceName: "Space Name",
    spaceColor: "Color",
    deleteSpace: "Delete Space",
    confirmDeleteSpace: "Are you sure you want to delete this space and all its tasks?",
    searchTasks: "Search tasks...",
    allSpaces: "All Spaces",
    upcoming: "Upcoming",
    deadlines: "Deadlines",
    noDeadlines: "No upcoming deadlines",
    of: "of",
    members: "members",
    tasks: "tasks",
    yourTodos: "Your to-do list",
    quickStats: "Quick Stats",
    acceptedFormats: "Accepted formats",
    uploading: "Uploading",
    leaveBlankKeep: "Leave blank to keep existing password",
    mentionAll: "Mention everyone",
    parentTask: "Parent Task",
    backToParent: "Back to parent",
    price: "Price",
    currency: "Currency",
    attachFiles: "Attach files",
    filesToUpload: "Files to upload",
    banking: "Banking",
    invoices: "Invoices",
    newInvoice: "New Invoice",
    amount: "Amount",
    dueDate: "Due Date",
    urgency: "Urgency",
    vendor: "Vendor",
    iban: "IBAN",
    invoiceNumber: "Invoice No",
    category: "Category",
    recurring: "Recurring",
    requiresApproval: "Requires Approval",
    open: "Open",
    approved: "Approved",
    inProgress: "In Progress",
    paid: "Paid",
    approve: "Approve",
    markPaid: "Mark Paid",
    invite: "Invite",
    inviteUser: "Invite User",
    sentInvitations: "Sent Invitations",
    setPassword: "Set Password",
    welcomeAccept: "Welcome to MyTACS! Set your password to activate your account.",
    invalidInvite: "Invitation invalid or expired",
    user: "User",
    master: "Master",
    spokenAt: "Conversation date",
    addSpokenAt: "Add conversation date",
    spokenOn: "Spoken on:",
    monthlyChart: "Monthly Overview",
    expensesByDay: "Expenses by day",
    selectMonth: "Select month",
    noExpenses: "No expenses this month",
    myTodos: "My Todos",
    newTodo: "New Todo",
    noTodos: "No todos yet",
    completedTodos: "Completed",
    openTodos: "Open",
    announcements: "Announcements",
    newAnnouncement: "New Announcement",
    announcementSent: "Announcement sent",
    announcementDescr: "This announcement will be shown as a popup to every user and will stay in the 'Announcements' section once acknowledged.",
    annTitlePlaceholder: "e.g. Use credit card X today",
    annContentPlaceholder: "Write the details...",
    markUrgent: "Mark as urgent",
    urgent: "URGENT",
    acknowledge: "I read and understood",
    from: "From:",
    send: "Send",
    content: "Content",
    online: "Online",
    offline: "Offline",
    lastSeen: "Last seen",
    phone: "Phone",
    personnelNumber: "Personnel No.",
    address: "Address",
    birthday: "Date of birth",
    hireDate: "Hire date",
    jobTitle: "Job title",
    emergencyContact: "Emergency contact",
    emergencyPhone: "Emergency phone",
    vacationQuota: "Annual vacation days",
    hrDetails: "HR Details",
    notes: "Notes",
    employees: "Employees",
    employeeDirectory: "Team Directory",
    sendMessage: "Send message",
    newEvent: "New Event",
    eventTitle: "Event title",
    visibility: "Visibility",
    personal: "Personal",
    team: "Team",
    company: "Company",
    location: "Location",
    allDay: "All day",
    color: "Color",
    vacation: "Vacation",
    vacations: "Vacations",
    newVacationRequest: "New Vacation Request",
    vacationType: "Vacation type",
    annualLeave: "Annual leave",
    specialLeave: "Special leave",
    unpaidLeave: "Unpaid leave",
    sickLeave: "Sick leave",
    substitute: "Substitute",
    reason: "Reason",
    workdays: "Workdays",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    decide: "Decide",
    quota: "Annual quota",
    used: "Used",
    remaining: "Remaining",
    onCall: "On-Call",
    newOnCall: "New On-Call",
    selectEmployee: "Select employee",
    whoIsOut: "Out today",
    assignToSpace: "Assign to whole department",
    claimTask: "Claim task",
    claimedBy: "Claimed by:",
    departmentTask: "Department task",
    attach: "Attach file",
    attachments: "Attachments",
    eventColor: "Color",
    chat: "Chat",
    newChat: "New Chat",
    newGroup: "New Group",
    groupName: "Group name",
    typeMessage: "Type a message...",
    noChats: "No chats yet — click 'New Chat'",
    noMessages: "No messages yet",
    selectChat: "Select a chat",
    members: "Members",
    typing: "typing...",
    icalSync: "Calendar Sync",
    icalDescr: "Subscribe to your MyTACS calendar in Apple Calendar, Google Calendar or Android. Read-only — updates sync automatically.",
    copyUrl: "Copy URL",
    copied: "Copied!",
    openInApple: "Open in Apple Calendar",
    customerComms: "Customer Communication",
    superchat: "Superchat",
    superchatStatus: "Connection status",
    superchatConfigured: "API key configured",
    superchatNotConfigured: "Not configured",
    channel: "Channel",
    whatsapp: "WhatsApp",
    sms: "SMS",
    email: "Email",
    instagram: "Instagram",
    contactId: "Contact ID",
    sendCustomerMessage: "Send to customer",
    settings: "Settings",
};

const de = {
    appName: "MyTACS",
    login: "Anmelden",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    loginTitle: "In Ihr Konto anmelden",
    loginSubtitle: "Willkommen im Aufgabenmanagementsystem Ihres Unternehmens",
    welcome: "Willkommen",
    dashboard: "Übersicht",
    spaces: "Abteilungen",
    calendar: "Kalender",
    admin: "Administration",
    notifications: "Benachrichtigungen",
    noNotifications: "Noch keine Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    created: "Erstellt",
    taken: "Übernommen",
    working: "In Bearbeitung",
    completed: "Erledigt",
    total: "Gesamt",
    newTask: "Neue Aufgabe",
    newSpace: "Neue Abteilung",
    title: "Titel",
    description: "Beschreibung",
    deadline: "Frist",
    priority: "Priorität",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    assignees: "Zugewiesen an",
    attachments: "Anhänge",
    subtasks: "Unteraufgaben",
    activity: "Aktivitätsverlauf",
    comments: "Kommentare",
    addComment: "Kommentar hinzufügen... (mit @ erwähnen)",
    addSubtask: "Unteraufgabe hinzufügen",
    uploadFile: "Datei hochladen",
    delete: "Löschen",
    save: "Speichern",
    cancel: "Abbrechen",
    create: "Erstellen",
    edit: "Bearbeiten",
    close: "Schließen",
    myTasks: "Meine Aufgaben",
    noTasks: "Keine Aufgaben",
    selectSpace: "Abteilung wählen",
    spaceMembers: "Mitglieder",
    addMember: "Mitglied hinzufügen",
    workers: "Benutzer",
    role: "Rolle",
    addWorker: "Benutzer hinzufügen",
    editUser: "Benutzer bearbeiten",
    name: "Name",
    deletionLog: "Löschprotokoll",
    confirmDelete: "Möchten Sie diese Aufgabe wirklich löschen?",
    status: "Status",
    createdAt: "Erstellt",
    createdBy: "Erstellt von",
    by: "von",
    assignedYou: "hat Ihnen eine Aufgabe zugewiesen",
    mentionedYou: "hat Sie erwähnt",
    today: "Heute",
    tomorrow: "Morgen",
    overdue: "Überfällig",
    spaceName: "Abteilungsname",
    spaceColor: "Farbe",
    deleteSpace: "Abteilung löschen",
    confirmDeleteSpace: "Möchten Sie diese Abteilung und alle ihre Aufgaben wirklich löschen?",
    searchTasks: "Aufgaben suchen...",
    allSpaces: "Alle Abteilungen",
    upcoming: "Bevorstehend",
    deadlines: "Fristen",
    noDeadlines: "Keine bevorstehenden Fristen",
    of: "von",
    members: "Mitglieder",
    tasks: "Aufgaben",
    yourTodos: "Ihre To-do-Liste",
    quickStats: "Schnellstatistiken",
    acceptedFormats: "Akzeptierte Formate",
    uploading: "Hochladen",
    leaveBlankKeep: "Leer lassen, um das vorhandene Passwort beizubehalten",
    mentionAll: "Alle erwähnen",
    parentTask: "Übergeordnete Aufgabe",
    backToParent: "Zur übergeordneten",
    price: "Preis",
    currency: "Währung",
    attachFiles: "Dateien anhängen",
    filesToUpload: "Hochzuladende Dateien",
    banking: "Banking",
    invoices: "Rechnungen",
    newInvoice: "Neue Rechnung",
    amount: "Betrag",
    dueDate: "Fälligkeitsdatum",
    urgency: "Dringlichkeit",
    vendor: "Empfänger",
    iban: "IBAN",
    invoiceNumber: "Rechnungs-Nr.",
    category: "Kategorie",
    recurring: "Wiederkehrend",
    requiresApproval: "Genehmigung erforderlich",
    open: "Offen",
    approved: "Genehmigt",
    inProgress: "In Arbeit",
    paid: "Bezahlt",
    approve: "Genehmigen",
    markPaid: "Als bezahlt markieren",
    invite: "Einladen",
    inviteUser: "Benutzer einladen",
    sentInvitations: "Gesendete Einladungen",
    setPassword: "Passwort festlegen",
    welcomeAccept: "Willkommen bei MyTACS! Legen Sie Ihr Passwort fest, um Ihr Konto zu aktivieren.",
    invalidInvite: "Einladung ungültig oder abgelaufen",
    user: "Benutzer",
    master: "Master",
    spokenAt: "Gesprächsdatum",
    addSpokenAt: "Gesprächsdatum hinzufügen",
    spokenOn: "Gespräch:",
    monthlyChart: "Monatsübersicht",
    expensesByDay: "Ausgaben pro Tag",
    selectMonth: "Monat wählen",
    noExpenses: "Keine Ausgaben in diesem Monat",
    myTodos: "Meine Todos",
    newTodo: "Neues Todo",
    noTodos: "Noch keine Todos",
    completedTodos: "Erledigt",
    openTodos: "Offen",
    announcements: "Neuigkeiten",
    newAnnouncement: "Neue Mitteilung",
    announcementSent: "Mitteilung gesendet",
    announcementDescr: "Diese Mitteilung wird allen Nutzern als Pop-up angezeigt und bleibt nach Bestätigung im 'Neuigkeiten'-Bereich erhalten.",
    annTitlePlaceholder: "z.B. Heute die Kreditkarte X verwenden",
    annContentPlaceholder: "Details schreiben...",
    markUrgent: "Als dringend markieren",
    urgent: "DRINGEND",
    acknowledge: "Gelesen und verstanden",
    from: "Von:",
    send: "Senden",
    content: "Inhalt",
    online: "Online",
    offline: "Offline",
    lastSeen: "Zuletzt gesehen",
    phone: "Telefon",
    personnelNumber: "Personalnummer",
    address: "Adresse",
    birthday: "Geburtstag",
    hireDate: "Eintrittsdatum",
    jobTitle: "Position",
    emergencyContact: "Notfallkontakt",
    emergencyPhone: "Notfallnummer",
    vacationQuota: "Jahresurlaubstage",
    hrDetails: "HR-Daten",
    notes: "Notizen",
    employees: "Mitarbeiter",
    employeeDirectory: "Mitarbeiterübersicht",
    sendMessage: "Nachricht senden",
    newEvent: "Neuer Termin",
    eventTitle: "Titel",
    visibility: "Sichtbarkeit",
    personal: "Persönlich",
    team: "Team",
    company: "Firma",
    location: "Ort",
    allDay: "Ganztägig",
    color: "Farbe",
    vacation: "Urlaub",
    vacations: "Urlaubsanträge",
    newVacationRequest: "Neuer Urlaubsantrag",
    vacationType: "Urlaubsart",
    annualLeave: "Erholungsurlaub",
    specialLeave: "Sonderurlaub",
    unpaidLeave: "Unbezahlter Urlaub",
    sickLeave: "Krankheitsurlaub",
    substitute: "Vertretung",
    reason: "Grund",
    workdays: "Arbeitstage",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    approve: "Genehmigen",
    reject: "Ablehnen",
    decide: "Entscheiden",
    quota: "Jahreskontingent",
    used: "Verbraucht",
    remaining: "Verbleibend",
    onCall: "Bereitschaft",
    newOnCall: "Neue Bereitschaft",
    selectEmployee: "Mitarbeiter wählen",
    whoIsOut: "Heute abwesend",
    assignToSpace: "Ganzer Abteilung zuweisen",
    claimTask: "Aufgabe übernehmen",
    claimedBy: "Übernommen von:",
    departmentTask: "Abteilungs-Aufgabe",
    attach: "Datei anhängen",
    attachments: "Anhänge",
    eventColor: "Farbe",
    chat: "Chat",
    newChat: "Neuer Chat",
    newGroup: "Neue Gruppe",
    groupName: "Gruppenname",
    typeMessage: "Nachricht eingeben...",
    noChats: "Noch keine Chats — klicke 'Neuer Chat'",
    noMessages: "Noch keine Nachrichten",
    selectChat: "Wähle einen Chat",
    members: "Mitglieder",
    typing: "schreibt...",
    icalSync: "Kalender-Synchronisation",
    icalDescr: "Abonniere deinen MyTACS-Kalender in Apple Calendar, Google Calendar oder Android. Read-only — Änderungen werden automatisch übertragen.",
    copyUrl: "URL kopieren",
    copied: "Kopiert!",
    openInApple: "In Apple Calendar öffnen",
    customerComms: "Kunden-Kommunikation",
    superchat: "Superchat",
    superchatStatus: "Verbindungsstatus",
    superchatConfigured: "API-Key konfiguriert",
    superchatNotConfigured: "Nicht konfiguriert",
    channel: "Kanal",
    whatsapp: "WhatsApp",
    sms: "SMS",
    email: "E-Mail",
    instagram: "Instagram",
    contactId: "Kontakt-ID",
    sendCustomerMessage: "An Kunde senden",
    settings: "Einstellungen",
};

const dicts = { tr, en, de };

export function getInitialLang() {
    return localStorage.getItem("taskflow_lang") || "de";
}

export function setLang(lang) {
    localStorage.setItem("taskflow_lang", lang);
}

export function t(lang, key) {
    return (dicts[lang] && dicts[lang][key]) || dicts.tr[key] || key;
}

export const LOCALES = { tr: "tr-TR", en: "en-US", de: "de-DE" };
